import { render } from "./HelloWorld.vue?vue&type=template&id=b9167eee&scoped=true&bindings={\"msg\":\"props\"}"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=b9167eee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b9167eee"

export default script